export enum ROUTES {
  //Used in `$router.push()`
  home = 'home',
  lists = 'lists',
  list = 'list',
  login = 'login',
  export = 'export',
  archive = 'archive',
}
